// Mocked until the wallet-service freeze/close endpoints exist.
const freeze = async () => Promise.resolve({ data: { status: 'frozen' } });

const close = async note => Promise.resolve({ data: { status: 'closed', note } });

const wallet = {
  freeze,
  close,
};

export default wallet;
